import React, { useEffect, useState } from 'react';
import { COOKIE_PARAM_NAME } from '../../consts/cookies.consts';
import { showPriceCredits } from '../../helpers/price';
import useMobileScreen from '../../services/hooks/useMobileScreen';
import { SIGN_UP_SRC } from '../../consts/profile.const';
import { AUTH_TESTS } from '../../pages/spot-view-page/auth-test.const';
import MobileSubPage from '../mobile-sub-page';
import ModalMobile from '../modal-mobile';
import SniffButton from '../sniff-button';
import SvgCircleCheck from 'src/assets/svg/SvgCircleCheck.svg';
import './index.scss';

const CookieService = require('../../services/cookie.service');

const ExtrasList = ({ extras }) => (
    <div className="extras-list">
        {extras.map((e, i) => {
            return (
                <div key={i}>
                    <div className="extras-item">
                        <SvgCircleCheck className="extras-icon" />
                        <div className="item-right">
                            <h4 className="extra-item-title snif-p snif-semibold">
                                <span>{e.title}</span>
                                <span className="text-primary">{showPriceCredits(e.price)}</span>
                            </h4>
                            <p className="extra-item-desc snif-p text-pre">{e.description}</p>
                        </div>
                    </div>
                    {extras.length - 1 !== i && <hr className="mb-3" />}
                </div>
            );
        })}
    </div>
);

const MobileExtrasModal = ({ showModal, toggleModal, useStateSSR, useEffectSSR, children }) => (
    <MobileSubPage title="Extras" show={showModal} onBack={toggleModal} mBottom={96} {...{ useStateSSR, useEffectSSR }}>
        {children}
    </MobileSubPage>
);

const DesktopExtrasModal = ({ showModal, toggleModal, children }) => (
    <ModalMobile title="Extras" isOpen={showModal} toggle={toggleModal}>
        {children}
    </ModalMobile>
);

export default function ListingExtras({ extras = [], useStateSSR, useEffectSSR, userDetails, setIsBlurTest = () => {}, isBlurTest }) {
    const isMobile = useMobileScreen();
    const [showModal, setShowModal] = useState(false);
    const [ExtrasModal, setExtrasModal] = useState(() => MobileExtrasModal);

    const toggleModal = async () => {
        const newShow = !showModal;

        // guest auth test
        if (!userDetails?.id) {
            const re = `${window.location.pathname}#${AUTH_TESTS.ALL_EXTRAS}`;

            CookieService.default.set(COOKIE_PARAM_NAME.SIGN_UP_FROM, SIGN_UP_SRC.SPOT_DETAILS_WEB, { expires: 1 });
            CookieService.default.set(COOKIE_PARAM_NAME.REDIRECT, re);
            setIsBlurTest(true);
            setShowModal(true);
        }

        setShowModal(newShow);
    };

    const ExtrasModalComp = (
        <ExtrasModal {...{ showModal, toggleModal, useStateSSR, useEffectSSR }}>
            <ExtrasList extras={extras} />
        </ExtrasModal>
    );

    useEffect(() => {
        if (!isMobile) {
            setExtrasModal(() => DesktopExtrasModal);
        }

        // guest auth test
        const urlHash = window.location.hash.substring(1);
        if (userDetails?.id && urlHash == AUTH_TESTS.ALL_EXTRAS) {
            setShowModal(true);
        }
    }, []);

    useEffect(() => {
        if (!isBlurTest && !userDetails?.id) {
            setShowModal(false);
        }
    }, [isBlurTest, userDetails?.id]);

    if (extras.length <= 0) {
        return '';
    }

    return (
        <div className="px-2 px-md-0">
            <h2 className="snif-m1 snif-semibold mb-3 mt-3">Extras</h2>
            <div className="extras-list">
                {extras.slice(0, 3).map((e, i) => {
                    return (
                        <div className="extras-item" key={i}>
                            <SvgCircleCheck className="extras-icon" />
                            <div className="item-right">
                                <h4 className="extra-item-title snif-p snif-semibold">
                                    <span>{e.title}</span>
                                    <span className="text-primary">{showPriceCredits(e.price)}</span>
                                </h4>
                                <p className="extra-item-desc snif-p text-pre">{e.description}</p>
                            </div>
                        </div>
                    );
                })}
            </div>
            {extras.length > 3 && (
                <>
                    <SniffButton color="secondary" size="lg" className="spot-extras-button" onClick={toggleModal}>
                        Show all {extras.length} extras
                    </SniffButton>
                    {ExtrasModalComp}
                </>
            )}
            <hr className="mt-0" />
        </div>
    );
}
